import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Loader2, CheckCircle2, XCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    fetch(`${API_URL}/api/auth/verify-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    })
      .then((r) => setStatus(r.ok ? 'success' : 'error'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4">
      <Card className="max-w-md w-full" data-testid="verify-email-card">
        <CardContent className="pt-8 pb-8 text-center space-y-4">
          {status === 'loading' && (
            <>
              <Loader2 className="w-12 h-12 text-[#2563EB] animate-spin mx-auto" />
              <p className="text-muted-foreground">Verificando tu correo...</p>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle2 className="w-14 h-14 text-green-500 mx-auto" />
              <h2 className="text-xl font-bold text-[#0F172A]">Correo verificado</h2>
              <p className="text-muted-foreground text-sm">Tu cuenta está activa. Revisa tu bandeja de entrada, te enviamos un correo de bienvenida.</p>
              <Link to="/dashboard">
                <Button className="bg-[#2563EB] hover:bg-[#1D4ED8] mt-2" data-testid="go-dashboard-btn">Ir a mi dashboard</Button>
              </Link>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="w-14 h-14 text-red-500 mx-auto" />
              <h2 className="text-xl font-bold text-[#0F172A]">Enlace inválido o expirado</h2>
              <p className="text-muted-foreground text-sm">El enlace de verificación no es válido o ya fue utilizado. Inicia sesión y solicita uno nuevo.</p>
              <Link to="/login">
                <Button variant="outline" className="mt-2" data-testid="go-login-btn">Iniciar sesión</Button>
              </Link>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
